/* FileGridViewComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./FileGridViewRenderer");
const Registrations = require("../../../../../RegistrationNamespaces");
const PagingFileServerFeed = require("./PagingFileFeed");

const _ = require("lodash");

const ImageTypeIconColumn = require("./column_renderers/image_type_icon/ImageTypeIconComponent");
const DateColumn = require("./column_renderers/date/DateComponent");
const VendorColumn = require("./column_renderers/detected_vendor/DetectedVendorComponent");
const NameColumn = require("./column_renderers/name/NameComponent");
const PathColumn = require("./column_renderers/path/PathComponent");
const FileSizeColumn = require("./column_renderers/file_size/FileSizeComponent");
const UploadProgressColumn = require("./column_renderers/upload_progress/UploadProgressComponent");

// const {IMAGE_TYPES_FILTER, VENDOR_LIST_FILTER} = require("../../fileConstants");

/**
 * @fires FileGridViewComponent#PathsEditingState
 */
class FileGridViewComponent extends EventEmitter {
    constructor(
        logger,
        gameEditor,
        OsImageEntity,
        OsImagePaths,
        OsImageServerEntity,
        userSession,
        storageFactory,
        solutionsManager,
        modalUserFeedback,
        osUpgradeInfoEntity
    ) {
        super();
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._userSession = userSession;
        this._modalUserFeedback = modalUserFeedback;
        this._sessionStorage = undefined;
        this._solutionsManager = solutionsManager;
        this._solutionName =
            (solutionsManager.activeSolution && solutionsManager.activeSolution.name) || "";
        this._gridKey = _.camelCase(this._solutionName) + "_" + "fileExplorer";

        this._storageFactory = storageFactory;
        this._userGridData = undefined;
        this._osImageEntity = OsImageEntity;
        this._OsImageServerEntity = OsImageServerEntity;
        this._osImagePathsEntity = OsImagePaths;
        this._osUpgradeInfoEntity = osUpgradeInfoEntity;
        this._osImagePaths = undefined;
        this._pagingFileServerFeed = undefined;
        this._explorerState = {
            selectedIds: [],
            selectedPathId: "",
        };
        //this.columns = undefined;
        this._sessionStorage = undefined;
        this._pathsData = [];

        this._imageTypeFilter = {};
        this._vendorListFilter = {};

        this._onImagePathsPristinePropertiesChanged =
            this._onImagePathsPristinePropertiesChanged.bind(this);
        this._onImagePathsReplacedByEntity = this._onImagePathsReplacedByEntity.bind(this);
        this._onImagePathsInitialized = this._onImagePathsInitialized.bind(this);
        this._onImagePathsEntityAdded = this._onImagePathsEntityAdded.bind(this);

        this._imageEntities = [];

        this._registerListeners();
        this._renderer = new Renderer(this);
    }

    get columnConfig() {
        return {
            imageType: {
                label: "Type",
                width: 45,
                columnRendererComponent: ImageTypeIconColumn,
                resizable: false,
                priority: 1,
                options: this._imageTypeFilter,
                groupable: true,
                shown: true,
                context: {
                    imageTypeFilter: this._imageTypeFilter,
                },
            },
            fileName: {
                label: "Name",
                priority: 2,
                width: 120,
                columnRendererComponent: NameColumn,
                entityColumn: true,
            },
            pathId: {
                label: "Path",
                priority: 3,
                width: 120,
                columnRendererComponent: PathColumn,
                context: {
                    osImagePaths: this._osImagePaths,
                },
                shown: false,
            },
            vendor: {
                label: "Vendor",
                priority: 4,
                width: 120,
                options: this._vendorListFilter,
                columnRendererComponent: VendorColumn,
                entityColumn: true,
                context: {
                    vendorListFilter: this._vendorListFilter,
                },
            },
            fileSize: {
                label: "File Size",
                width: 120,
                priority: 6,
                columnRendererComponent: FileSizeColumn,
                entityColumn: true,
                dataType: "double",
            },
            checksum: {
                label: "Checksum",
                path: "checksums.md5",
                width: 240,
                priority: 6,
                dataType: "double",
                shown: false,
            },
            uploaded: {
                label: "Uploaded %",
                width: 120,
                priority: 7,
                columnRendererComponent: UploadProgressColumn,
                entityColumn: true,
            },
            createdBy: {
                label: "Created By",
                priority: 8,
                width: 120,
                updateFromEntity: true,
            },
            createdOn: {
                label: "Created On",
                priority: 9,
                width: 120,
                columnRendererComponent: DateColumn,
                updateFromEntity: true,
            },
            updatedBy: {
                label: "Updated By",
                priority: 10,
                width: 120,
            },
            updatedOn: {
                label: "Updated On",
                priority: 11,
                width: 120,
                columnRendererComponent: DateColumn,
            },
            status: {
                label: "Status",
                priority: 11,
                width: 120,
            },
        };
    }

    get pagingFeed() {
        return this._pagingFileServerFeed;
    }

    get storageFactory() {
        return this._storageFactory;
    }

    get selectedRows() {
        return this._renderer.selectedRows;
    }

    get activeOrgId() {
        return _.get(this._userSession, "activeOrganization.id");
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        this._gameEditor.on(
            "ImageServersUpdated",
            (this._onImageServersUpdated = this._onImageServersUpdated.bind(this))
        );
    }

    _registerOsImagePathsListeners(osImagePaths) {
        osImagePaths
            .on("PristinePropertiesChanged", this._onImagePathsPristinePropertiesChanged)
            .on("ReplacedByEntity", this._onImagePathsReplacedByEntity)
            .on("Initialized", this._onImagePathsInitialized)
            .on("EntityAdded", this._onImagePathsEntityAdded);
    }

    _registerMasterImageServerFeedListeners(masterImageServerFeed) {
        const onMasterServerUpdated = this._onMasterServerUpdated.bind(this);
        masterImageServerFeed
            .on("ChangeFeedInitialized", onMasterServerUpdated)
            .on("EntityPropertiesUpdated", onMasterServerUpdated)
            .on("EntityAdded", onMasterServerUpdated)
            .on("EntityRemoved", onMasterServerUpdated)
            .on("EntityInitialized", onMasterServerUpdated)
            .once("ShutdownStarted", () =>
                masterImageServerFeed
                    .removeListener("ChangeFeedInitialized", onMasterServerUpdated)
                    .removeListener("EntityPropertiesUpdated", onMasterServerUpdated)
                    .removeListener("EntityAdded", onMasterServerUpdated)
                    .removeListener("EntityRemoved", onMasterServerUpdated)
                    .removeListener("EntityInitialized", onMasterServerUpdated)
            );
    }

    _unregisterListeners() {
        if (this._gameEditor) {
            this._gameEditor.removeListener("ImageServersUpdated", this._onImageServersUpdated);
        }
        this._unregisterOsImagePathsListeners(this._osImagePaths);
    }

    _unregisterOsImagePathsListeners(osImagePaths) {
        if (osImagePaths) {
            osImagePaths
                .removeListener(
                    "PristinePropertiesChanged",
                    this._onImagePathsPristinePropertiesChanged
                )
                .removeListener("ReplacedByEntity", this._onImagePathsReplacedByEntity)
                .removeListener("Initialized", this._onImagePathsInitialized)
                .removeListener("EntityAdded", this._onImagePathsEntityAdded);
        }
    }

    _patchSorting(sorting) {
        if (typeof sorting === "string") {
            sorting = JSON.parse(sorting);
        }
        if (sorting && !sorting.name && this.columnConfig.name) {
            sorting.name = 1;
        }
    }

    _triggerPathsEditingState(pathsEditingState) {
        /**
         * @event FileGridViewComponent#PathsEditingState
         * @param {boolean}
         */
        this.emit("PathsEditingState", pathsEditingState);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    whenModelIsReady() {
        return Promise.race([
            this.initializeComponentData(),
            new Promise((resolve, reject) =>
                this.once("Shutdown", () => reject({errorMsg: "Shutdown"}))
            ),
        ]);
    }

    initializeComponentData() {
        return Promise.all([
            this.getOsImagePaths(this.activeOrgId),
            this.setUpStorage(),
            this._osUpgradeInfoEntity.loadOsUpgradeInfo(this.activeOrgId, {
                imageTypeFilter: true,
                vendorListFilter: true,
            }),
            this.establishMasterServerFeed(),
            this.loadOsImages(),
        ])
            .then(([osImagePaths, explorerState, osUpgradeInfo]) => {
                const paths = osImagePaths.getPaths();
                const stateSelectedPathId = _.get(explorerState, "selectedPathId");

                if (osUpgradeInfo) {
                    this._imageTypeFilter = osUpgradeInfo.getImageTypeFilter() || {};
                    this._vendorListFilter = osUpgradeInfo.getVendorListFilter() || {};
                }

                if (stateSelectedPathId && !paths.find(({id}) => id === stateSelectedPathId)) {
                    this.updateExplorerState("selectedPathId", "");
                }
                this._pathsData = this.groupTree(paths);
            })
            .then(() => this.updateGridData(this.activeOrgId));
    }

    loadOsImages() {
        if (_.get(this._gameEditor._openEditorFromUrl, "selectedIds", false)) {
            const query = {
                $and: [{id: {$in: _.get(this._gameEditor._openEditorFromUrl, "selectedIds", [])}}],
            };
            return this._osImageEntity
                .loadAscendOsImages(this.activeOrgId, query, {}, false, false)
                .then((imageEntities) => {
                    this._imageEntities = imageEntities;
                    return Promise.resolve();
                });
        } else {
            return Promise.resolve();
        }
    }

    setUpStorage() {
        return this._storageFactory.whenStorageIsReady().then(() => {
            if (!this._gridKey) {
                return Promise.reject({errorMsg: "No gridKey for storage"});
            }

            this._userGridData = this._storageFactory.getRemoteStorageInstanceForEntityGrid(
                "file_grid_gl",
                this._gridKey
            );
            this._sessionStorage = this._storageFactory.getSessionStorageInstance(
                "file_grid_gl",
                `${this._gridKey}_explorerState`
            );
            this._explorerState = Object.assign(
                {},
                this._explorerState,
                this._sessionStorage.getData()
            );
            return this._explorerState;
        });
    }
    getOsImagePaths(orgId) {
        if (!orgId) {
            return Promise.reject({errorMsg: "No orgId for 'getOsImagePaths()'"});
        }

        return this._osImagePathsEntity
            .retrievePaths(orgId)
            .then((osImagePaths) => {
                return osImagePaths ? osImagePaths : new this._osImagePathsEntity(orgId).create();
            })
            .then((osImagePaths) => {
                if (this.activeOrgId !== orgId) {
                    //Active org has been changed while retrieving osImagePaths Entity.
                    osImagePaths.shutdown();
                    return;
                }
                this._setOsImagePaths(osImagePaths);
                return osImagePaths;
            });
    }

    establishMasterServerFeed() {
        const orgId = this.activeOrgId;
        const query = {
            $and: [
                {
                    $or: [
                        {
                            identifier: "MAIN",
                        },
                        {
                            isGsg: true,
                        },
                    ],
                },
                {
                    enabled: true,
                },
            ],
        };
        const fields = {status: true};

        if (this._masterImageServerFeed) {
            this._masterImageServerFeed.reestablishFeed(orgId, query, fields);
        } else {
            this._masterImageServerFeed = this._OsImageServerEntity.startAscendOsImageServersFeed(
                orgId,
                query,
                fields
            );
            this._registerMasterImageServerFeedListeners(this._masterImageServerFeed);
        }

        return this._masterImageServerFeed;
    }

    updateGridData(orgId) {
        if (!orgId) {
            return Promise.reject({errorMsg: "No orgId for 'updateGridData()'"});
        }
        const userSorting = this._userGridData.getSorting() || {};
        this._patchSorting(userSorting);

        this._pagingFileServerFeed = new PagingFileServerFeed({
            feedKey: this._gridKey + "_feed",
            activeOrgId: orgId,
            entityDef: this._osImageEntity,
            columnConfig: this.columnConfig,
            filter: {
                pathId: this.getTreeDefaultSelection(),
            },
            sort: userSorting,
            additionalDataFields: ["status", "name"],
        });

        return this._pagingFileServerFeed.whenFeedReady().then((feed) => {
            if (this.activeOrgId !== orgId) {
                // Active org has been changed while establishing feed.
                feed.shutdown();
                return;
            }
            return feed;
        });
    }

    get renderer() {
        return this._renderer;
    }

    get logger() {
        return this._logger;
    }

    shutdown() {
        this.emit("Shutdown");
        this._unregisterListeners();
        let shutdowns = [
            _.invoke(this._renderer, "shutdown") || Promise.resolve(),
            _.invoke(this._osImagePaths, "shutdown") || Promise.resolve(),
            _.invoke(this._pagingFileServerFeed, "shutdown") || Promise.resolve(),
            _.invoke(this._masterImageServerFeed, "shutdown") || Promise.resolve(),
        ];
        this.removeAllListeners();
        return Promise.all(shutdowns).then(
            () => {
                this._logger = undefined;
                this._gameEditor = undefined;
                this._steveUtils = undefined;
                this._userSession = undefined;
                this._modalUserFeedback = undefined;
                this._sessionStorage = undefined;
                this._solutionsManager = undefined;
                this._solutionName = undefined;
                this._gridKey = undefined;
                this._imageEntities = undefined;
                // this._storageFactory = undefined;
                this._userGridData = undefined;
                this._osImageEntity = undefined;
                this._OsImageServerEntity = undefined;
                // this._osImagePathsEntity = undefined;
                this._pagingFileServerFeed = undefined;
                this._explorerState = undefined;
                //this.columns = undefined;
                this._sessionStorage = undefined;
                this._imageTypeFilter = undefined;
                this._vendorListFilter = undefined;
                this._osUpgradeInfoEntity = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "FileGridViewComponent.shutdown() error");
            }
        );
    }

    get gameEditor() {
        return this._gameEditor;
    }

    get explorerState() {
        return this._explorerState;
    }

    set explorerState(val) {
        this.setExplorerState(val);
    }

    get userGridData() {
        return this._userGridData;
    }

    set userGridData(newData) {
        this.setUserGridData(newData);
    }

    setUserGridData(newData) {
        this._userGridData = newData;
    }

    setExplorerState(val) {
        this._explorerState = val;
    }

    updateExplorerState(property, val) {
        this._sessionStorage.setData(val, property);
        //this.updateGridData();
        _.set(this._explorerState, property, val);
    }

    resetSelection(newIds) {
        let selectedIds = [];

        if (newIds && newIds.length) {
            newIds.forEach((id) => {
                selectedIds.push(id);
            });
        }

        this.renderer._fileManagerEntityGrid.setSelectedRows(selectedIds);
        this.updateExplorerState("selectedIds", {selectedRows: selectedIds});
        this.renderer._renderAvailableActions();
    }

    loadAndScrollTo(entityId) {
        let that = this;
        this.pagingFeed.on("RequestedEntityFound", handleRequestedEntityFound);
        this.pagingFeed._requestEntity(entityId);

        function handleRequestedEntityFound(index) {
            that.renderer._fileManagerEntityGrid.renderer.scrollToTheRow(index);
            that.pagingFeed.removeListener("RefreshView", handleRequestedEntityFound);
        }
    }

    groupTree(data) {
        let map = {};
        data.forEach((item) => {
            let obj = item;
            obj.children = [];

            if (_.isEmpty(map[obj.id])) {
                map[obj.id] = obj;
            } else {
                obj.children = _.get(map[obj.id], "children", []);
                map[obj.id] = obj;
            }

            let parentId = obj.parentId || "-";
            if (!map[parentId]) {
                map[parentId] = {
                    children: [],
                };
            }

            map[parentId].children.push(obj);
        });

        if (data.length > 0 && map["-"]) {
            let folderStructure = map["-"].children;
            return this._recursiveSortFolderItems(folderStructure);
        }
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    onUserSorted(sortData) {
        let sort = {};

        const sortCriteria =
            this.columnConfig[sortData.sortColumn].valuePath ||
            this.columnConfig[sortData.sortColumn].path ||
            sortData.sortColumn;

        sort[sortCriteria] = sortData.sort === "asc" ? 1 : -1;
        this._patchSorting(sort);
        this._pagingFileServerFeed.setSort(sort);
    }

    _onSolutionChanged(solution) {
        // whole pane will be reset, no need to make any action here
        this._solutionName = solution.name;
    }

    _onImagePathsPristinePropertiesChanged(/*props, before*/) {
        const paths = this._osImagePaths.getPaths();
        const selectedPathId = _.get(this._explorerState, "selectedPathId");
        if (!_.some(paths, ["id", selectedPathId])) {
            this.updateExplorerState("selectedPathId", "");
        }

        this.refreshTree();
        this._pagingFileServerFeed.reestablish();
    }

    _onImagePathsReplacedByEntity(newOsImagePaths) {
        this.updateExplorerState("selectedPathId", "");
        this._setOsImagePaths(newOsImagePaths);
        this.refreshTree();
        this._pagingFileServerFeed.reestablish();
    }

    _onImagePathsInitialized() {
        this.refreshTree();
        this._pagingFileServerFeed.reestablish();
    }
    _onImagePathsEntityAdded() {
        this.refreshTree();
        this._pagingFileServerFeed.reestablish();
    }

    _onMasterServerUpdated() {
        this._updateFileCreateState(this.canCreateFiles());
    }

    _onImageServersUpdated(servers) {
        this._updateFileActionsState(!_.isEmpty(servers));
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    _setOsImagePaths(osImagePaths) {
        this._unregisterOsImagePathsListeners(this._osImagePaths);
        this._osImagePaths = osImagePaths;
        this._registerOsImagePathsListeners(osImagePaths);

        this._updatePathsEditingState(this.canEditFolders(osImagePaths));
        return this;
    }

    _updatePathsEditingState(pathsEditingState) {
        this._gameEditor.toggleGameEditorActions(
            Registrations.FILE_EXPLORER_ACTION_RENAME_FOLDER,
            pathsEditingState
        );
        this._gameEditor.toggleGameEditorActions(
            Registrations.FILE_EXPLORER_ACTION_CREATE_FOLDER,
            pathsEditingState
        );

        this._triggerPathsEditingState(pathsEditingState);
    }

    _updateFileCreateState(state) {
        this._gameEditor.toggleGameEditorActions(
            Registrations.FILE_EXPLORER_ACTION_CREATE_FILE,
            state
        );
    }

    _updateFileActionsState(state) {
        this._gameEditor.toggleGameEditorActions(
            Registrations.FILE_EXPLORER_ACTION_EDIT_FILE,
            state
        );
        this._gameEditor.toggleGameEditorActions(
            Registrations.FILE_EXPLORER_ACTION_DELETE_FILE,
            state
        );
    }

    _recursiveSortFolderItems(folders) {
        if (folders.length > 1) {
            folders = _.sortBy(folders, ["name"]);
        }
        return folders.map((folder) => {
            if (folder.children.length > 0) {
                folder.children = this._recursiveSortFolderItems(folder.children);
            }
            return folder;
        });
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setSelectedPath(path) {
        return _.set(this._explorerState, "selectedPathId", path);
    }

    getSelectedPath() {
        if (this._pathsData === undefined) {
            return null;
        }
        return _.get(this._explorerState, "selectedPathId") || this.getTreeDefaultSelection();
    }
    getSelectedImageIds() {
        return _.get(this._explorerState, "selectedIds", []);
    }
    openFileManagerInstanceEditor(imageIds, fullyQualifiedViewName) {
        imageIds = [].concat(imageIds);
        let viewName;
        let title = "";

        if (imageIds.length > 1) {
            viewName = Registrations.FILE_VIEW_MULTIEDIT;
            title = `Multi-Edit (${imageIds.length})`;
        } else {
            viewName = Registrations.FIE_VIEW_DETAILS;
            let osImage = this._pagingFileServerFeed.getEntityById(imageIds[0]);

            if (_.isEmpty(osImage)) {
                osImage = this._imageEntities.filter((entity) => entity.getId() === imageIds[0])[0];
            }

            title = osImage.name || "";
        }
        viewName = fullyQualifiedViewName || viewName;
        this.updateExplorerState("openedEditor", {fqn: viewName, id: imageIds, title});
        this._gameEditor.launchFileEditor(
            {
                fqn: viewName,
            },
            {
                imageIds,
                title,
            }
        );
    }

    refreshTree(pathToSelect) {
        const paths = this._osImagePaths.getPaths();
        this._pathsData = this.groupTree(paths);
        this.renderer._treeComponent.updateTree(this._pathsData);
        if (this._pathsData === undefined) {
            this.renderer._showDefaultMessageDisplay();
        } else {
            pathToSelect = pathToSelect || this.getTreeDefaultSelection();
            const selectedPathId = _.get(this._explorerState, "selectedPathId");

            if (selectedPathId !== pathToSelect) {
                this.updateFolderSelection(pathToSelect, true);
            } else {
                this._setActiveFolder(pathToSelect);
            }
        }
    }

    updateFolderSelection(pathToSelect, silent) {
        this._setActiveFolder(pathToSelect);
        this.pagingFeed._pathData = {pathId: pathToSelect};
        this.pagingFeed.setFilter({pathId: pathToSelect}, silent);
    }

    _canMove(fromId, toId) {
        const paths = this._osImagePaths.getPaths();
        const nodesMap = paths.reduce((map, node) => {
            const {id, parentId} = node;
            map[parentId] = map[parentId] || {};
            map[id] = map[id] || {children: []};

            Object.assign(map[id], node);

            if (parentId === null) {
                map[parentId] = map[id];
            } else {
                map[id].parent = map[parentId];
                map[parentId].children = map[parentId].children || [];
                map[parentId].children.push(map[id]);
            }
            return map;
        }, {});
        const checkHierarchy = (map, fromId, toId) => {
            let destinationIsNotNested = true;
            let item = nodesMap[toId];
            while (destinationIsNotNested && item) {
                destinationIsNotNested = fromId !== item.id;
                item = item.parent;
            }
            return destinationIsNotNested;
        };

        // prettier-ignore
        return (
            (nodesMap[fromId] && nodesMap[toId]) && //make sure both source and destination are exist
            !!nodesMap[fromId].parent &&            //make sure we are not moving root folder
            fromId !== toId &&                      //make sure we are not moving folder to itself
            toId !== nodesMap[fromId].parent.id &&  //make sure we are not moving to folder's parent
            checkHierarchy(nodesMap, fromId, toId)  //make sure we are not moving folder to nested one
        );
    }

    /* jshint ignore:start */
    async moveFolder(fromId, toId) {
        if (this._canMove(fromId, toId)) {
            let osip = this._osImagePaths;
            osip.movePath(fromId, toId);
            await osip.update();
        }
    }
    /* jshint ignore:end */

    getTreeDefaultSelection() {
        if (this._pathsData !== undefined) {
            if (this._pathsData.length > 0 && this._explorerState.selectedPathId === "") {
                return this._pathsData[0].id;
            } else if (this._explorerState.selectedPathId !== "") {
                return this._explorerState.selectedPathId;
            }
        }
        return "";
    }

    _setActiveFolder(activeFolderId) {
        let folderNodes = this._renderer._treeComponent.getTreeNodes(),
            activeNode =
                folderNodes.find((folder) => folder.id === activeFolderId) || folderNodes[0];

        this._renderer._treeComponent.setSelectedNode(activeNode);
        this.updateExplorerState("selectedPathId", activeNode.id || "");
    }

    canEditFolders(osImagePaths = this._osImagePaths) {
        //Can only be created, updated or deleted if the activeOrgId matches the entity's tenantId
        const fileServersEnabled = true === _.get(osImagePaths, "fileServersEnabled");
        const samePathsEntityTenant = this.activeOrgId === _.get(osImagePaths, "tenantId");
        return fileServersEnabled && samePathsEntityTenant;
    }

    canCreateFiles() {
        //Can only be created if the status is "SYNCING" or "IN_SYNC".
        const allowedStatuses = ["SYNCING", "IN_SYNC"];
        const [masterServer] = _.invoke(this._masterImageServerFeed, "getCacheAsArray") || [];
        const masterServerStatus = masterServer && masterServer.getStatus();

        return (
            allowedStatuses.includes(masterServerStatus) &&
            this._userSession.user.authorizedActions.includes("fileWrite")
        );
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = FileGridViewComponent;

FileGridViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.entities.OsImage",
    "$teve.entities.OsImagePaths",
    "$teve.entities.OsImageServer",
    "$teve.userSession",
    "$teve.storageFactory",
    "$teve.solutionsManager",
    "$teve.ui.userFeedback",
    "$teve.entities.OsUpgradeInfo",
];

FileGridViewComponent.$displayDetails = {
    type: "View",
    name: "",
    icon: "common.duplicate",
    shown: false,
    order: 2,
};
